import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { StarRatingComponent } from '@comparit/core';
import type { ErgebnisInput } from '../../interfaces/ergebnis-input.model';
import { RatingTooltipComponent } from '../rating-tooltip/rating-tooltip.component';

/** One tariff's card in the sticky "Deine Tarifauswahl" header of the comparison page. */
@Component({
  selector: 'ui-compare-bar-item',
  templateUrl: './compare-bar-item.component.html',
  styleUrl: './compare-bar-item.component.scss',
  imports: [CurrencyPipe, MatButtonModule, StarRatingComponent, RatingTooltipComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareBarItemComponent {
  readonly logo = input<string | null>(null);
  readonly ergebnis = input.required<ErgebnisInput>();
  readonly isBest = input(false);

  readonly openAntrag = output<ErgebnisInput>();
}
